import { lhHttpClient } from './httpClient';

export interface LocationData {
	location: Location;
}

export interface Location {
	id: number;
	product: string;
	usesShift4PaymentProcessor: boolean;
	sicCode: string;
	terminalProducts: string[];
	phone: string;
	email: string;
	website: string | null;
	addressLine1: string;
	addressLine2: string | null;
	city: string;
	state: string;
	zip: string;
	country: string;
	logoUrl: string | null;
	timezone: string;
	name: string;
	merchantId: string;
	countryCode: string;
	legalName: string | null;
	shift4Serial: string | null;
	shift4Mid: string | null;
	locationKey: string | null;
	isCorpHq: boolean;
	corpId: number | null;
	accountStatus: string | null;
	isMenuComplete?: boolean;
	terminalMaxVersions: {
		product: string;
		maxVersion: string | null;
	}[];
	terminalMinVersions: {
		product: string;
		minVersion: string | null;
	}[];
	firstTransactionDate: string | null;
}

export const getLocation = async (locationId: number) => {
	return (await lhHttpClient.get<LocationData>(`/api/v2/locations/${locationId}`)).data;
};
